var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPastryChef(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 22C3.71667 22 3.47917 21.9042 3.2875 21.7125C3.09583 21.5208 3 21.2833 3 21V16C3 15.45 3.19583 14.9792 3.5875 14.5875C3.97917 14.1958 4.45 14 5 14V10C5 9.45 5.19583 8.97917 5.5875 8.5875C5.97917 8.19583 6.45 8 7 8H11V6.55C10.7 6.35 10.4583 6.10833 10.275 5.825C10.0917 5.54167 10 5.2 10 4.8C10 4.55 10.05 4.30417 10.15 4.0625C10.25 3.82083 10.4 3.6 10.6 3.4L12 2L13.4 3.4C13.6 3.6 13.75 3.82083 13.85 4.0625C13.95 4.30417 14 4.55 14 4.8C14 5.2 13.9083 5.54167 13.725 5.825C13.5417 6.10833 13.3 6.35 13 6.55V8H17C17.55 8 18.0208 8.19583 18.4125 8.5875C18.8042 8.97917 19 9.45 19 10V14C19.55 14 20.0208 14.1958 20.4125 14.5875C20.8042 14.9792 21 15.45 21 16V21C21 21.2833 20.9042 21.5208 20.7125 21.7125C20.5208 21.9042 20.2833 22 20 22H4ZM7 14H17V10H7V14ZM5 20H19V16H5V20Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastryChef);
export default __webpack_public_path__ + "static/media/pastry-chef.d135e1f193609d030b5b8b68b3fc437d.svg";
export { ForwardRef as ReactComponent };